import { useId } from 'react';

function Input({ endAdornment, error, hint, id, label, required = false, ...props }) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const errorId = error ? `${inputId}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;
  return (
    <div className="field">
      <label className="field__label" htmlFor={inputId}>{label} {required && <span aria-hidden="true">*</span>}</label>
      <div className="field__control-wrap">
        <input aria-describedby={describedBy} aria-invalid={Boolean(error)} className="field__control" id={inputId} required={required} {...props} />
        {endAdornment}
      </div>
      {hint && <p className="field__hint" id={hintId}>{hint}</p>}
      {error && <p className="field__error" id={errorId} role="alert">{error}</p>}
    </div>
  );
}
export default Input;
